import styled from '@emotion/styled'
import MuiRadio from '@mui/material/Radio'

export const Radio = styled(MuiRadio)`
  && {
    padding: 0;
  }
`
